import { DefaultButton, Icon, IconButton, PrimaryButton } from 'office-ui-fabric-react';
import { SelectionMode } from 'office-ui-fabric-react/lib/DetailsList';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import React, { Component, Fragment } from 'react';
import { DataReservation } from '../../../data/DataReservation';
import { DataReservation_Echeancier_Stade } from '../../../data/DataReservation_Echeancier_Stade';
import { Immocom } from '../../../specifique/immocom';
import { EUIDetailsList } from '../../EUI/EUIDetailsList';
import { EUIDialog } from '../../EUI/EUIDialog';
import { EUISeparator } from '../../EUI/EUISeparator';
import { FicheReservation } from '../../Fiche/FicheReservation';
import { ProgressIndicatorChargement } from '../../Loader/ProgressIndicatorChargement';
import { MessageBars } from '../../Outils/MessageBars';
import { PanelAppelDeFonds } from './PanelAppelDeFonds';
import { PanelExportDocuments } from './PanelExportDocuments';
import { PanelFiltres } from './PanelFiltres';
import { PanelRelancesEtCourriers } from './PanelRelancesEtCourriers';
import { SyntheseAppelsDeFonds } from './SyntheseAppelsDeFonds';

export class DetailsListAppelDeFonds extends Component {

    static defaultProps = {
        perimetre: {},
    };

    static defaultState = {
        dateDernierPublipostageEffectue: undefined,
        itemActif: {},
        items: [],
        itemsSelectionnes: [],
        /* --- */
        pageIndex: 1,
        facteurNbreEnregistrement: 250,
        /* --- */
        hideMessageBarFiltres: true,
        hideMessageBarWarning: true,
        hideMessageBarError: true
    };

    constructor(props) {
        super(props);
        this._columns = this._getColumns(false);
        this._filtres = this._getFiltres();
        this._isSortedDescending = false;
        this._sortedColumn = "numero";
        this.state = { ...DetailsListAppelDeFonds.defaultState };
    };

    _appliquerFiltres = (filtres) => {
        this._filtres = { ...this._filtres, ...filtres };
        this.setState({ pageIndex: 1 });
        this._togglePanel("Filtres", false, null, true)();
    };

    _chargementDonnees = () => {
        const { items, facteurNbreEnregistrement } = this.state;

        // N'implémenter la pagination que si aucune opération n'est sélectionnée dans le périmètre
        const pageIndex = !this.props.perimetre.idOperation ? this.state.pageIndex : -1;

        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Chargement en cours..."
        });

        DataReservation._chargementListeAppelsDeFond(this._filtres, this._sortedColumn, this._isSortedDescending, facteurNbreEnregistrement, pageIndex)
            .then(responseFetch => {
                const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                if (retourVerif === null) {
                    const appelsDeFonds = responseFetch.reponseAPIobjet || [];

                    let newItems = [];
                    if (pageIndex <= 1) {
                        newItems = appelsDeFonds;
                    }
                    else {
                        newItems = [...items];
                        newItems = newItems.concat(appelsDeFonds);
                    }

                    const state = { items: newItems };
                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, state);
                }
                else {
                    const state = { items: [] };
                    Immocom.onTraitementErreurAvecState(this, state, retourVerif, responseFetch);
                }
            });
    };

    _getColumns = (activerVueDetaillee) => {
        const { perimetre } = this.props;

        let columns = [
            {
                isIconOnly: true,
                key: "enabled",
                onRender: (item) => {
                    const { dateSignatureActe, verrouille } = item;
                    const styles = { root: { color: !!dateSignatureActe && !!verrouille ? "green" : "red" } };
                    return <Icon iconName="FullCircleMask" styles={styles} />;
                }
            },
            {
                key: "acquereurs",
                name: "Acquéreurs",
            },
            {
                key: "numero",
                minWidth: 30,
                name: "N°",
            },
            {
                key: "etage",
                minWidth: 30,
                name: "Étage",
            },
        ];

        if (!perimetre.idOperation) columns.push(
            {
                className: "ms-hiddenXlDown",
                headerClassName: "ms-hiddenXlDown",
                key: "ville",
                name: "Ville",
            },
            {
                className: "ms-hiddenXlDown",
                headerClassName: "ms-hiddenXlDown",
                key: "nomCommercial",
                name: "Opération",
            },
        );

        columns.push(
            {
                key: "prixVenteTTC",
                minWidth: 60,
                name: "Prix TTC",
            },
            {
                key: "cycleReservation",
                name: "Cycle",
            }
        );

        if (activerVueDetaillee)
            columns.push(
                {
                    headerName: "Prochain exigible",
                    key: "nomStadeProchainExigible",
                    minWidth: 150,
                    name: "Prochain stade exigible",
                },
                {
                    headerName: "Prochain exigible",
                    key: "dateProchainExigible",
                    name: "Date",
                },
                {
                    headerName: "Prochain exigible",
                    key: "pourcentageCumulProchainExigible",
                    minWidth: 60,
                    name: "Cumulé",
                    onRender: (item) => {
                        const { pourcentageCumulProchainExigible } = item;
                        if (!!pourcentageCumulProchainExigible) {
                            const title = `${parseFloat(pourcentageCumulProchainExigible * 100).toFixed(10)} %`;
                            return <span style={{ display: "block", textAlign: "right" }} title={title}>{parseFloat(pourcentageCumulProchainExigible * 100).toFixed(2)}&nbsp;%</span>;
                        }
                    }
                }
            );

        columns.push(
            {
                headerName: "Avancement travaux",
                key: "pourcentageCumulDernierAvance",
                minWidth: 60,
                name: "Cumulé",
                onRender: (item) => {
                    const { pourcentageCumulDernierAvance } = item;
                    if (!!pourcentageCumulDernierAvance) {
                        const title = `${parseFloat(pourcentageCumulDernierAvance * 100).toFixed(10)} %`;
                        return <span style={{ display: "block", textAlign: "right" }} title={title}>{parseFloat(pourcentageCumulDernierAvance * 100).toFixed(2)}&nbsp;%</span>;
                    }
                }
            },
            {
                headerName: "Avancement travaux",
                key: "nomStadeDernierAvance",
                minWidth: 150,
                name: "Dernier stade avancé",
            },
            {
                headerName: "Appel de fonds",
                key: "dateAppele",
                name: "Date",
            },
            {
                headerName: "Appel de fonds",
                key: "nomStadeAppele",
                minWidth: 150,
                name: "Dernier stade appelé",
            },
            {
                headerName: "Appel de fonds",
                key: "pourcentageCumulAppele",
                minWidth: 60,
                name: "Cumulé",
                onRender: (item) => {
                    const { pourcentageCumulAppele } = item;
                    if (!!pourcentageCumulAppele) {
                        const title = `${parseFloat(pourcentageCumulAppele * 100).toFixed(10)} %`;
                        return <span style={{ display: "block", textAlign: "right" }} title={title}>{parseFloat(pourcentageCumulAppele * 100).toFixed(2)}&nbsp;%</span>;
                    }
                }
            },
            {
                headerName: "Montants",
                key: "montantTotalTTCAppele",
                name: "Appelé",
            },
            {
                headerName: "Montants",
                key: "montantTotalTTCReglement",
                name: "Encaissé",
            },
            {
                headerName: "Montants",
                key: "montantTotalTTCDu",
                name: "Dû",
            },
            {
                isIconOnly: true,
                key: "edit",
                onRender: (item) => {
                    return <IconButton
                        iconProps={{ iconName: "Edit" }}
                        onClick={this._togglePanel("Reservation", true, item, false)}
                        title="Afficher la réservation"
                    />;
                }
            }
        );

        return columns;
    };

    _getFarMenuItems = () => {
        let farItems = [];

        if (!!sessionStorage.loginCompte && sessionStorage.loginCompte.startsWith("ImmocomGestNat"))
            farItems.push({
                toggle: true,
                checked: !!this.state && this.state.activerVueDetaillee,
                iconProps: { iconName: "Zoom" },
                key: "details",
                name: "Vue détaillée",
                onClick: (_, self) => {
                    this._columns = this._getColumns(!self.checked);
                    this.setState({ activerVueDetaillee: !self.checked });
                }
            });

        return farItems;
    };

    _getFiltres = () => {
        const { idOperation } = this.props.perimetre;
        let filtres = { ...PanelFiltres.defaultState };
        if (!!idOperation) filtres.idOperation = idOperation;
        return filtres;
    };

    _getItems = () => {

        const { perimetre } = this.props;
        const { itemsSelectionnes } = this.state;

        const testSelectionAndTogglePanel = (panelName) => () => {
            const idStadeDeReference = itemsSelectionnes[0].idStadeProchainExigible;
            let error = null;

            const estSelectionIneligible = itemsSelectionnes.some(item => {
                const { dateSignatureActe, idStadeProchainExigible, verrouille } = item;
                if (!dateSignatureActe || !verrouille)
                    error = "Une ou plusieurs réservations sélectionnées ne remplissent pas les conditions pour votre action (date de signature d’acte manquante ou réservation non verrouillée)";
                if (idStadeProchainExigible !== idStadeDeReference)
                    error = "Une ou plusieurs réservations sélectionnées ne partagent pas le même prochain stade exigible";
                return !!error;
            });

            if (estSelectionIneligible) this.setState({ warningMessage: error });
            else {
                this.setState({ warningMessage: "" });
                this._togglePanel(panelName, true, null, false)();
            }
        };

        let items = [
            {
                disabled: !perimetre.idOperation || itemsSelectionnes.length === 0,
                iconProps: { iconName: "Add" },
                key: "ADF",
                name: "Appel de fonds",
                onClick: testSelectionAndTogglePanel("ADF")
            },
            {
                disabled: !perimetre.idOperation || itemsSelectionnes.length === 0,
                iconProps: { iconName: "Add" },
                key: "relancesEtCourriers",
                name: "Relances et courriers",
                onClick: this._togglePanel("RelancesEtCourriers", true, null, false)
            },
            {
                disabled: !perimetre.idOperation || itemsSelectionnes.length === 0,
                iconProps: { iconName: "Delete" },
                key: "delete",
                text: "Supprimer",
                subMenuProps: {
                    items: [
                        {
                            iconProps: { iconName: "Trash" },
                            key: "last",
                            onClick: this._toggleDialog("SuppressionDernierADF", true, false),
                            text: "Supprimer derniers appel de fonds",
                        },
                        {
                            iconProps: { iconName: "Trash" },
                            key: "all",
                            onClick: this._toggleDialog("SuppressionTousADF", true, false),
                            text: "Supprimer tous les appels de fonds",
                        },
                    ]
                }
            },
            {
                disabled: !perimetre.idOperation,
                iconProps: { iconName: "Upload" },
                key: "export",
                name: "Export documents",
                onClick: this._togglePanel("ExportDocuments", true, null, false)
            },
        ];

        return items;
    };

    _onColumnHeaderClick = (sortedColumn, isSortedDescending) => {
        this._sortedColumn = sortedColumn;
        this._isSortedDescending = isSortedDescending;
        this.setState({ pageIndex: 1 }, this._chargementDonnees);
    };

    _onScroll = () => {
        const { facteurNbreEnregistrement } = this.state;
        if (facteurNbreEnregistrement > 0)
            this.setState(
                prevState => ({ pageIndex: prevState.pageIndex + 1 }),
                this._chargementDonnees
            );
    };

    _onSearch = (keyword) => {
        this._filtres.recherche = keyword;
        this.setState({ pageIndex: 1 }, this._chargementDonnees);
    };

    _onSelectionChanged = (items) => {
        this.setState({ itemsSelectionnes: items });
    };

    _supprimer = (deleteAll) => () => {
        const { perimetre } = this.props;
        const { idOperation } = perimetre;
        const { itemsSelectionnes } = this.state;

        if (itemsSelectionnes.length > 0) {
            this.setState({
                afficherDialogSuppressionDernierADF: false,
                afficherDialogSuppressionTousADF: false,
                enCoursDeTraitement: true,
                messageEnCoursTraitement: "Suppression en cours..."
            });

            let reservation_Echeancier_Stades = [];
            let promises = [];

            itemsSelectionnes.forEach(item => {
                const { idEcheancier, idReservation, idStadeAppele } = item;
                // Si suppression de tous les appels de fonds alors d'abord récupérer tous les stades
                if (deleteAll) {
                    const filtres = {
                        idOperation, idReservation, idEcheancier,
                        inclureStadesAvecDateADF: true,
                        inclureStadesSansDateADF: false,
                    };
                    promises.push(DataReservation_Echeancier_Stade._chargementReservation_Echeancier_Stades(filtres));
                }
                // Sinon supprimer le dernier stade appelé (s'il existe)
                else if (!!idStadeAppele) {
                    let reservation_Echeancier_Stade = {
                        idOperation, idReservation, idEcheancier,
                        idStade: idStadeAppele,
                        dateADF: null
                    };
                    reservation_Echeancier_Stades.push(reservation_Echeancier_Stade);
                }
            });

            Promise.all(promises).then(responses => {
                // Récupération de tous les stades pour suppression de tous les ADF
                responses.forEach(responseFetch => {
                    const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                    if (retourVerif === null) {
                        const stades = responseFetch.reponseAPIobjet || [];
                        stades.forEach(reservation_Echeancier_Stade => {
                            reservation_Echeancier_Stades.push({
                                ...reservation_Echeancier_Stade,
                                dateADF: null
                            });
                        })
                    } else {
                        Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
                        return;
                    }
                });

                DataReservation_Echeancier_Stade._onEnregistrementReservation_Echeancier_Stades(reservation_Echeancier_Stades, false)
                    .then(responseFetch => {
                        const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                        if (retourVerif === null)
                            Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, {}, true, this._chargementDonnees);
                        else Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
                    });
            })
        }
    };

    _toggleDialog = (nomDialog, isOpen, rechargerLesDonnees) => () => {
        this.setState(
            { [`afficherDialog${nomDialog}`]: isOpen },
            rechargerLesDonnees ? this._chargementDonnees : null
        );
    };

    _togglePanel = (nomPanel, isOpen, item, rechargerLesDonnees) => () => {
        this.setState({
            [`afficherPanel${nomPanel}`]: isOpen,
            itemActif: item || {},
        }, rechargerLesDonnees ? this._chargementDonnees : null);
    };

    componentDidMount = () => {
        this._chargementDonnees();
    };

    componentDidUpdate = (prevProps) => {
        const { perimetre } = this.props;
        if (JSON.stringify(perimetre) !== JSON.stringify(prevProps.perimetre)) {
            this._chargementDonnees();
            this._filtres.idOperation = perimetre.idOperation;
        }
    };

    render = () => {

        const { perimetre } = this.props;
        const { afficherDialogSuppressionDernierADF, afficherDialogSuppressionTousADF, afficherPanelADF, afficherPanelExportDocuments, afficherPanelFiltres, afficherPanelRelancesEtCourriers, afficherPanelReservation } = this.state;
        const { dateDernierPublipostageEffectue, itemActif, items, itemsSelectionnes } = this.state;

        const reservationsJamaisAppelees = itemsSelectionnes.filter(item => !item.idStadeAppele);
        const reservationsGroupeesParDernierStadeAppele = itemsSelectionnes.reduce((memo, reservation) => {
            const groupName = reservation.nomStadeAppele || "";
            if (!memo[groupName])
                memo[groupName] = [];
            memo[groupName].push(reservation);
            return memo;
        }, {});

        return <Fragment>

            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

            <Stack verticalFill>
                <MessageBars
                    errorMessage={this.state.errorMessage}
                    infoMessage={this.state.messageMessageBarFiltres}
                    warningMessage={this.state.warningMessage}
                    onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                    onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                />
                <EUIDetailsList
                    columns={this._columns}
                    getKey={item => `${item.idOperation};${item.idReservation};${item.idLotCommercial}`}
                    farMenuItems={this._getFarMenuItems()}
                    isSortedDescending={this._isSortedDescending}
                    items={items}
                    menuItems={this._getItems()}
                    onColumnHeaderClick={this._onColumnHeaderClick}
                    onFilterButtonClick={this._togglePanel("Filtres", true)}
                    onSelectionChanged={this._onSelectionChanged}
                    onScroll={!perimetre.idOperation ? this._onScroll : undefined}
                    onSearch={this._onSearch}
                    selectionMode={SelectionMode.multiple}
                    sortedColumn={this._sortedColumn}
                />
                {!!perimetre.idOperation &&
                    <Fragment>
                        <EUISeparator />
                        <Stack.Item styles={{ root: { marginLeft: "30%" } }}>
                            <SyntheseAppelsDeFonds
                                items={items}
                                itemsSelectionnes={itemsSelectionnes}
                            />
                        </Stack.Item>
                    </Fragment>
                }
            </Stack>

            <PanelFiltres
                filtres={this._filtres}
                isHiddenOnDismiss
                isOpen={afficherPanelFiltres}
                onValidate={this._appliquerFiltres}
                onDismiss={this._togglePanel("Filtres", false, null, false)}
            />

            <FicheReservation
                idLotCommercial={itemActif.idLotCommercial}
                idOperation={itemActif.idOperation}
                idReservation={itemActif.idReservation}
                inclureVentesEnBloc
                onAffichePanelReservation={afficherPanelReservation}
                onChangeDeReservation={newIdReservation => {
                    const reservation = items.find(item => item.idOperation === perimetre.idOperation && item.idReservation === newIdReservation);
                    this.setState({ itemActif: reservation });
                }}
                onFermeFicheReservation={this._togglePanel("Reservation", false, null, true)}
            />

            <PanelAppelDeFonds
                idOperation={perimetre.idOperation}
                items={items}
                itemsSelectionnes={itemsSelectionnes}
                isOpen={afficherPanelADF}
                onDismiss={this._togglePanel("ADF", false, null, true)}
                onEnregistrement={() => this.setState({ dateDernierPublipostageEffectue: Date.now() })}
            />

            <PanelExportDocuments
                forceUpdate={dateDernierPublipostageEffectue}
                idOperation={perimetre.idOperation}
                isOpen={afficherPanelExportDocuments}
                onDismiss={this._togglePanel("ExportDocuments", false, null, false)}
            />

            <PanelRelancesEtCourriers
                idOperation={perimetre.idOperation}
                isOpen={afficherPanelRelancesEtCourriers}
                itemsSelectionnes={itemsSelectionnes}
                onDismiss={this._togglePanel("RelancesEtCourriers", false, null, false)}
                onEnregistrement={() => {
                    this.setState({ dateDernierPublipostageEffectue: Date.now() }, () => {
                        this._togglePanel("RelancesEtCourriers", false, null, false)();
                        this._togglePanel("ExportDocuments", true, null, false)();
                    });
                }}
            />

            <EUIDialog
                buttons={[
                    <PrimaryButton key="delete" onClick={this._supprimer(false)} text="Supprimer" />,
                    <DefaultButton key="cancel" onClick={this._toggleDialog("SuppressionDernierADF", false, false)} text="Annuler" />
                ]}
                isOpen={afficherDialogSuppressionDernierADF}
                onDismiss={this._toggleDialog("SuppressionDernierADF", false, false)}
                titre="Suppression des derniers ADF"
            >
                <div>Confirmez-vous la suppression du dernier appel de fonds des réservations sélectionnées ?</div>
                <ul>
                    {Object.keys(reservationsGroupeesParDernierStadeAppele).map(nomStade => {
                        if (!!nomStade) {
                            const text = `${nomStade} : ${reservationsGroupeesParDernierStadeAppele[nomStade].length}`;
                            return <li key={nomStade}>{text}</li>;
                        }
                    })}
                </ul>
                {reservationsJamaisAppelees.length > 0 && <div>Remarque : parmi les réservations sélectionnées il existe {reservationsJamaisAppelees.length} réservation(s) sur lesquelles aucun appel de fonds n'a été effectué. Sur ces réservations la suppression du dernier appel de fonds n'aura donc aucun effet.</div>}
            </EUIDialog>

            <EUIDialog
                buttons={[
                    <PrimaryButton key="delete" onClick={this._supprimer(true)} text="Supprimer" />,
                    <DefaultButton key="cancel" onClick={this._toggleDialog("SuppressionTousADF", false, false)} text="Annuler" />
                ]}
                isOpen={afficherDialogSuppressionTousADF}
                onDismiss={this._toggleDialog("SuppressionTousADF", false, false)}
                titre="Suppression de tous les ADF"
            >
                <div>Confirmez-vous la suppression de tous les appels de fonds des réservations sélectionnées ?</div>
                {reservationsJamaisAppelees.length > 0 && <div>Remarque : parmi les réservations sélectionnées il existe {reservationsJamaisAppelees.length} réservation(s) sur lesquelles aucun appel de fonds n'a été effectué. Sur ces réservations la suppression de tous les appels de fonds n'aura donc aucun effet.</div>}
            </EUIDialog>

        </Fragment >;

    };

};